import { render, staticRenderFns } from "./user-role.vue?vue&type=template&id=513aa0da&"
import script from "./user-role.vue?vue&type=script&lang=js&"
export * from "./user-role.vue?vue&type=script&lang=js&"
import style0 from "./user-role.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports